import { render, staticRenderFns } from "./site-map-block.vue?vue&type=template&id=4a3908ea&scoped=true"
import script from "./site-map-block.vue?vue&type=script&lang=ts"
export * from "./site-map-block.vue?vue&type=script&lang=ts"
import style0 from "./site-map-block.vue?vue&type=style&index=0&id=4a3908ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3908ea",
  null
  
)

export default component.exports